<template>
    <div id="insights-audio-player">
        <div class="landing-player-container">
            <div class="landing-player row no-gutters">
                <div class="col-auto">
                    <div
                        class="play-pause-button"
                        :class="{ 'play-running' : isChanging }"
                        @click.prevent="togglePlay"
                    >
                        <svg
                            v-if="!playing"
                            width="34"
                            height="34"
                            viewBox="0 0 24 24"
                        >
                            <path fill="#fec72e" fill-rule="nonzero" d="M17.828 11.185l-7.507-5.938c-.344-.258-.787-.329-1.181-.14-.394.163-.64.539-.64.961v11.876c0 .422.246.798.64.962.148.07.32.094.468.094.246 0 .516-.094.713-.235l7.507-5.937c.247-.212.394-.493.394-.822 0-.305-.147-.61-.394-.821z" />
                        </svg>
                        <svg
                            v-else
                            width="34"
                            height="34"
                            viewBox="0 0 24 24"
                        >
                            <path fill="#fec72e" fill-rule="nonzero" d="M17.137 18.342V5.658A.671.671 0 0 0 16.453 5h-2.267a.671.671 0 0 0-.683.658v12.684c0 .363.306.658.683.658h2.267a.671.671 0 0 0 .684-.658M9.95 19H7.683A.67.67 0 0 1 7 18.342V5.658A.67.67 0 0 1 7.683 5h2.268c.377 0 .683.294.683.658v12.684a.671.671 0 0 1-.683.658" />
                        </svg>
                    </div>
                </div>
                <div class="col">
                    <div class="player-progress-container">
                        <div class="player-progress" :style="{ width: playerProgress +'%' }" />
                    </div>
                </div>
                <div class="col-auto">
                    <div class="player-counter">
                        {{ countdown | formatSeconds }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


import audioPlayerMixin from "@/mixins/audioPlayerMixins";

export default {
    name: "LandingInsightsPlayer",
    mixins: [audioPlayerMixin],
    props: {
        preload: {
            type: Boolean,
            default: false
        }
    }
}
</script>
<style lang="scss">
   .landing-player {
        align-items: center;
        margin-top: 40px;

        .play-pause-button {
            width: 46px;
            height: 46px;
            background-color: #52504E;
            border-radius: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            margin-right: 20px;
            transform: rotate(0deg) scale(1);

            &.play-running {
                transform: rotate(0deg) scale(1.3);
            }
        }

        .player-progress-container {
            height: 15px;
            background-color: #2E2E2E;
            width: 100%;
            border-radius: 10px;
            overflow: hidden;
            transition: width 1s;

            .player-progress {
                    height: 100%;
                    border-radius: 10px;
                    background: linear-gradient(to right, rgba(44,155,173,1) 0%, rgba(91,45,194,1) 100%);
                }
        }

        .player-counter {
            margin-left: 20px;
            font-size: 15px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.4px;
        }
    }
</style>
